import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.644 15.342V.668h14.694V13.13l-2.228 2.212H.644zM0 16h16V0H0v16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 7.144c.39.279.614.733.6 1.212a1.51 1.51 0 0 1-.444 1.114c-.4.4-1.032.574-1.686.574a2.672 2.672 0 0 1-.982-.176l-.044-.016c.416.271.904.41 1.4.4.656 0 1.28-.166 1.686-.572.297-.294.457-.698.444-1.116a1.464 1.464 0 0 0-.974-1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.038 6.368l-.322-.206h-.99l.372.206z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.166 9.11a.934.934 0 0 1-.278-.654l-.378-.2a.97.97 0 0 0 .278.65.93.93 0 0 0 .4.22l-.022-.016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.648 7.972l-.138-.028c-.074-.012-.58-.066-.644-.072-.032 0-.842-.082-1.114-.288l-.05-.028-.018-.012H2.67c.11.037.222.064.336.082.354.06.82.076 1.182.144.17.022.33.092.46.202zM4.428 5.582a1.44 1.44 0 0 0-.35-.046 1.26 1.26 0 0 0-.898.304.762.762 0 0 0-.18.588.544.544 0 0 0 .092.232.552.552 0 0 1-.468-.566.614.614 0 0 1 .182-.452 1.2 1.2 0 0 1 .866-.294c.27-.003.535.079.756.234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8 8.354c.012.417-.148.821-.444 1.116-.4.4-1.032.574-1.686.574a2.342 2.342 0 0 1-1.6-.552 1.704 1.704 0 0 1-.556-1.242h1a.934.934 0 0 0 .278.654c.248.209.566.315.89.296.37 0 .724-.076.926-.288A.664.664 0 0 0 4.82 8.4a.55.55 0 0 0-.172-.42.892.892 0 0 0-.46-.212c-.362-.068-.828-.084-1.182-.144a2.06 2.06 0 0 1-.336-.082l-.018-.012c.12.043.243.074.368.094.136.024.29.04.448.056l-.126-.02a1.762 1.762 0 0 1-.2-.044 1.448 1.448 0 0 1-1.148-1.464c.006-.404.173-.79.466-1.068a2.216 2.216 0 0 1 1.4-.566c.485.018.949.2 1.318.514.326.291.52.701.54 1.138h-1a.874.874 0 0 0-.234-.528.51.51 0 0 0-.06-.052 1.29 1.29 0 0 0-.752-.234 1.2 1.2 0 0 0-.866.294.614.614 0 0 0-.182.452c-.01.28.19.524.468.566l.074.014c.34.054.814.092 1.16.136.802.104 1.474.626 1.474 1.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.342 7.652l.126.02a6.364 6.364 0 0 1-.448-.056 2.068 2.068 0 0 1-.368-.094l.018.012a1.418 1.418 0 0 1-1.02-1.4c.006-.4.175-.781.468-1.054.42-.37.961-.57 1.52-.564h.218a2.216 2.216 0 0 0-1.4.566c-.293.279-.46.664-.466 1.068A1.448 1.448 0 0 0 3.136 7.6c.068.021.136.039.206.052z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.716 6.162l.322.2v-.186a1.652 1.652 0 0 0-.542-1.152A2.188 2.188 0 0 0 4 4.504h-.16c.488.016.956.197 1.328.514.33.291.528.704.548 1.144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.878 9.914C2.2 9.576 1.97 8.82 1.9 8.456a2.034 2.034 0 0 1-.03-.2h-.362c.01.417.168.816.444 1.128a1.931 1.931 0 0 0 .68.468l.046.018a3 3 0 0 0 .296.094l-.096-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.644 7.608v2.42l.374.226V7.608zM7.644 5.424v1.28h.374v-1.28zM10.952 4.76l-.392-.254v.92l.392.256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.018 4.506v.918l2.542.002V4.506zM8.018 6.704h1.804v1H8.018zM7.036 4.506v5.522h.608V4.506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.952 5.678l-.392-.254H7.644l.336.254z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.192 6.948l-.368-.244v.904l.368.248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 7.864l-.376-.256h-2.18l.336.256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.644 4.506h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.646 4.506h1v5.522h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.644 6.704h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.996 10.254h1.022l-.374-.226h-.998l.35.226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.106 8.01l1.152-1.804-.092-.14-1.318 1.992 1.332 2.034.394.166zM12.626 7.276l-.646-.96-.46-.252.968 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.836 10.092l.198.166h.686l-.148-.166zM13.424 10.092l.208.166h.942l-.394-.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.474 8.628l-.902 1.464.148.166.874-1.438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.228 7.88l.256-.378-.964-1.438-.726.002h.284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.848 8.058l1.318-1.992h-.794l-.884 1.438-.004-.002-.256.378.104.164-.134.204-1.188 1.844h.562l.902-1.464.95 1.464h.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.228 7.88l-1.15-1.814h-.284l1.254 1.976.036.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.198 8.248l.134-.204-.104-.164-.144.212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.118 8.038l-1.282 2.054h.178l1.22-1.892z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.848 8.058l-.36-.554.138-.228.366.564z"
  })));
});